// extracted by mini-css-extract-plugin
export default {"landingPage":"Campaign5_landingPage__tH5qE","landingImg":"Campaign5_landingImg__ciqMG","tcButton":"Campaign5_tcButton__DsLoj"};